/* Copyright 2021, Milkdown by Mirone. */
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
export const createMouseManager = () => {
    let mouseLock = false;
    return {
        isLock: () => mouseLock,
        lock: () => {
            mouseLock = true;
        },
        unlock: () => {
            mouseLock = false;
        },
    };
};
export const handleMouseMove = (mouseManager) => () => {
    mouseManager.unlock();
};
export const handleMouseEnter = (status, mouseManager) => (e) => {
    if (mouseManager.isLock())
        return;
    const active = status.get().activeActions.findIndex((x) => x.$.classList.contains('active'));
    if (active >= 0) {
        status.get().activeActions[active].$.classList.remove('active');
    }
    const { target } = e;
    if (!(target instanceof HTMLElement))
        return;
    target.classList.add('active');
};
export const handleMouseLeave = () => (e) => {
    const { target } = e;
    if (!(target instanceof HTMLElement))
        return;
    target.classList.remove('active');
};
export const handleClick = (status, items, view, dropdownElement) => (e) => {
    const { target } = e;
    if (!(target instanceof HTMLElement))
        return;
    if (!view)
        return;
    const stop = () => {
        e.stopPropagation();
        e.preventDefault();
    };
    const el = Object.values(items).find(({ $ }) => $.contains(target));
    if (!el) {
        if (status.isEmpty())
            return;
        status.clearStatus();
        dropdownElement.classList.add('hide');
        stop();
        return;
    }
    stop();
    el.command(view.state, view.dispatch, view);
};
export const handleKeydown = (status, view, dropdownElement, mouseManager) => (e) => {
    if (!(e instanceof KeyboardEvent))
        return;
    if (!mouseManager.isLock())
        mouseManager.lock();
    const { key } = e;
    if (!status.isSlash())
        return;
    if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(key))
        return;
    const { activeActions } = status.get();
    let active = activeActions.findIndex(({ $ }) => $.classList.contains('active'));
    if (active < 0)
        active = 0;
    const moveActive = (next) => {
        activeActions[active].$.classList.remove('active');
        activeActions[next].$.classList.add('active');
        scrollIntoView(activeActions[next].$, {
            scrollMode: 'if-needed',
            block: 'nearest',
            inline: 'nearest',
        });
    };
    if (key === 'ArrowDown') {
        const next = active === activeActions.length - 1 ? 0 : active + 1;
        moveActive(next);
        return;
    }
    if (key === 'ArrowUp') {
        const next = active === 0 ? activeActions.length - 1 : active - 1;
        moveActive(next);
        return;
    }
    if (key === 'Escape') {
        if (status.isEmpty())
            return;
        status.clearStatus();
        dropdownElement.classList.add('hide');
        return;
    }
    activeActions[active].command(view.state, view.dispatch, view);
    activeActions[active].$.classList.remove('active');
};
//# sourceMappingURL=input.js.map